import { useQuery, ArrayQueryKey } from "react-query";
import useNetworkHeaders from "../../../../hooks/useNetworkHeaders";
import { getPermitForm } from "../../../../queries/permitsForms";

export default function usePermitForm(id: string | number) {
  const headers = useNetworkHeaders();
  const key = getPermitFormQueryKey(id);

  const query = useQuery(key, getPermitForm(headers), {
    enabled: !!id,
    queryFnParamsFilter: (key) => {
      return [key[1]];
    },
  });
  // TODO: This should NOT return the whole query object - I'm doing it here for easing into using the new permits client
  return query;
}

export function getPermitFormQueryKey(id: string | number): ArrayQueryKey {
  return ["permits-form", id];
}
